import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { FaBriefcase, FaCode, FaChartBar, FaFilePdf, FaCheckCircle } from 'react-icons/fa';
import '../styles/pages/Career.scss';

function Career() {
  const navigate = useNavigate();
  const location = useLocation();
  const jobsRef = useRef(null);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showApplicationModal, setShowApplicationModal] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [applicationForm, setApplicationForm] = useState({
    name: '',
    email: '',
    phone: '',
    cover_letter: '',
    resume: null
  });
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [formError, setFormError] = useState('');

  const [showInternshipModal, setShowInternshipModal] = useState(false);
  const [showSoftwareEnquiryModal, setShowSoftwareEnquiryModal] = useState(false);
  const [showMbaEnquiryModal, setShowMbaEnquiryModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [cardInternshipType, setCardInternshipType] = useState('Software Development');

  const handleOpenInternshipModal = () => {
    setInternshipForm(prev => ({
      ...prev,
      internshipType: cardInternshipType,
      internshipSubtype: cardInternshipType === 'Software Development' ? 'Python' : 'Marketing'
    }));
    setShowInternshipModal(true);
  };
  
  const [oppSubmitting, setOppSubmitting] = useState(false);
  const [oppError, setOppError] = useState('');
  const [submittedId, setSubmittedId] = useState('');

  const [internshipForm, setInternshipForm] = useState({
    fullName: '',
    mobile: '',
    email: '',
    collegeName: '',
    university: '',
    currentYear: '',
    city: '',
    internshipType: 'Software Development',
    internshipSubtype: 'Python',
    preferredMode: 'Online',
    resume: null,
    message: ''
  });

  const [softwareForm, setSoftwareForm] = useState({
    fullName: '',
    mobile: '',
    email: '',
    college: '',
    projectTitle: '',
    projectRequirement: '',
    technology: 'Python',
    projectType: 'Mini Project',
    document: null
  });

  const [mbaForm, setMbaForm] = useState({
    fullName: '',
    mobile: '',
    email: '',
    college: '',
    university: '',
    projectTitle: '',
    specialization: 'Marketing',
    projectRequirement: '',
    document: null
  });

  const handleOppSubmit = async (e, type) => {
    e.preventDefault();
    setOppError('');
    
    let formData = new FormData();
    let apiEndpoint = '';
    let formValues = {};
    
    if (type === 'internship') {
      formValues = internshipForm;
      if (!formValues.fullName.trim() || !formValues.mobile.trim() || !formValues.email.trim() || !formValues.collegeName.trim() || !formValues.university.trim() || !formValues.currentYear.trim() || !formValues.city.trim()) {
        setOppError('❌ All fields marked with * are required');
        return;
      }
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formValues.email.trim())) {
        setOppError('❌ Please enter a valid email address');
        return;
      }
      if (!/^[6-9]\d{9}$/.test(formValues.mobile.trim())) {
        setOppError('❌ Please enter a valid 10-digit Indian mobile number');
        return;
      }
      if (formValues.resume) {
        const resumeExt = formValues.resume.name.toLowerCase().substring(formValues.resume.name.lastIndexOf('.'));
        if (resumeExt !== '.pdf') {
          setOppError('❌ Invalid resume file format. Only PDF files are allowed');
          return;
        }
        if (formValues.resume.size > 10 * 1024 * 1024) {
          setOppError('❌ Resume file size exceeds 10MB maximum limit');
          return;
        }
        formData.append('resume', formValues.resume);
      }
      
      formData.append('full_name', formValues.fullName.trim());
      formData.append('mobile', formValues.mobile.trim());
      formData.append('email', formValues.email.trim().toLowerCase());
      formData.append('college_name', formValues.collegeName.trim());
      formData.append('university', formValues.university.trim());
      formData.append('current_year', formValues.currentYear.trim());
      formData.append('city', formValues.city.trim());
      formData.append('internship_type', `${formValues.internshipType} - ${formValues.internshipSubtype}`);
      formData.append('preferred_mode', formValues.preferredMode);
      if (formValues.message.trim()) {
        formData.append('message', formValues.message.trim());
      }
      apiEndpoint = '/internships';
    } 
    else if (type === 'software') {
      formValues = softwareForm;
      if (!formValues.fullName.trim() || !formValues.mobile.trim() || !formValues.email.trim() || !formValues.projectTitle.trim() || !formValues.projectRequirement.trim()) {
        setOppError('❌ All fields marked with * are required');
        return;
      }
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formValues.email.trim())) {
        setOppError('❌ Please enter a valid email address');
        return;
      }
      if (!/^[6-9]\d{9}$/.test(formValues.mobile.trim())) {
        setOppError('❌ Please enter a valid 10-digit Indian mobile number');
        return;
      }
      if (formValues.document) {
        const allowedExtensions = ['.pdf', '.doc', '.docx'];
        const ext = formValues.document.name.toLowerCase().substring(formValues.document.name.lastIndexOf('.'));
        if (!allowedExtensions.includes(ext)) {
          setOppError('❌ Invalid document format. Only PDF, DOC, and DOCX are allowed');
          return;
        }
        if (formValues.document.size > 10 * 1024 * 1024) {
          setOppError('❌ Document file size exceeds 10MB maximum limit');
          return;
        }
        formData.append('requirement_document', formValues.document);
      }
      
      formData.append('full_name', formValues.fullName.trim());
      formData.append('mobile', formValues.mobile.trim());
      formData.append('email', formValues.email.trim().toLowerCase());
      if (formValues.college.trim()) {
        formData.append('college', formValues.college.trim());
      }
      formData.append('project_title', formValues.projectTitle.trim());
      formData.append('project_requirement', formValues.projectRequirement.trim());
      formData.append('technology', formValues.technology);
      formData.append('project_type', formValues.projectType);
      apiEndpoint = '/software-project-enquiries';
    } 
    else if (type === 'mba') {
      formValues = mbaForm;
      if (!formValues.fullName.trim() || !formValues.mobile.trim() || !formValues.email.trim() || !formValues.college.trim() || !formValues.university.trim() || !formValues.projectTitle.trim()) {
        setOppError('❌ All fields marked with * are required');
        return;
      }
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formValues.email.trim())) {
        setOppError('❌ Please enter a valid email address');
        return;
      }
      if (!/^[6-9]\d{9}$/.test(formValues.mobile.trim())) {
        setOppError('❌ Please enter a valid 10-digit Indian mobile number');
        return;
      }
      if (formValues.document) {
        const allowedExtensions = ['.pdf', '.doc', '.docx'];
        const ext = formValues.document.name.toLowerCase().substring(formValues.document.name.lastIndexOf('.'));
        if (!allowedExtensions.includes(ext)) {
          setOppError('❌ Invalid document format. Only PDF, DOC, and DOCX are allowed');
          return;
        }
        if (formValues.document.size > 10 * 1024 * 1024) {
          setOppError('❌ Document file size exceeds 10MB maximum limit');
          return;
        }
        formData.append('requirement_document', formValues.document);
      }
      
      formData.append('full_name', formValues.fullName.trim());
      formData.append('mobile', formValues.mobile.trim());
      formData.append('email', formValues.email.trim().toLowerCase());
      formData.append('college', formValues.college.trim());
      formData.append('university', formValues.university.trim());
      formData.append('project_title', formValues.projectTitle.trim());
      formData.append('specialization', formValues.specialization);
      if (formValues.projectRequirement.trim()) {
        formData.append('project_requirement', formValues.projectRequirement.trim());
      }
      apiEndpoint = '/mba-project-enquiries';
    }

    try {
      setOppSubmitting(true);
      const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8002/api';
      const response = await axios.post(`${API_BASE}${apiEndpoint}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      // Close all modals
      setShowInternshipModal(false);
      setShowSoftwareEnquiryModal(false);
      setShowMbaEnquiryModal(false);
      
      const resId = response.data?.data?.application_id || response.data?.data?.enquiry_id || 'N/A';
      setSubmittedId(resId);
      setShowSuccessModal(true);
      
      // Reset forms
      if (type === 'internship') {
        setInternshipForm({
          fullName: '',
          mobile: '',
          email: '',
          collegeName: '',
          university: '',
          currentYear: '',
          city: '',
          internshipType: 'Software Development',
          internshipSubtype: 'Python',
          preferredMode: 'Online',
          resume: null,
          message: ''
        });
      } else if (type === 'software') {
        setSoftwareForm({
          fullName: '',
          mobile: '',
          email: '',
          college: '',
          projectTitle: '',
          projectRequirement: '',
          technology: 'Python',
          projectType: 'Mini Project',
          document: null
        });
      } else if (type === 'mba') {
        setMbaForm({
          fullName: '',
          mobile: '',
          email: '',
          college: '',
          university: '',
          projectTitle: '',
          specialization: 'Marketing',
          projectRequirement: '',
          document: null
        });
      }
    } catch (err) {
      const msg = err.response?.data?.detail || 'An error occurred during submission. Please try again.';
      setOppError(`❌ ${msg}`);
      console.error(err);
    } finally {
      setOppSubmitting(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      setLoading(true);
      const hostname = window.location.hostname;
      const API_BASE = (hostname && hostname !== 'localhost' && hostname !== '127.0.0.1')
        ? 'https://pravarainfotech.in/api'
        : (process.env.REACT_APP_API_URL || 'http://localhost:8000/api');
      const response = await axios.get(`${API_BASE}/jobs`);
      console.log('Jobs API Response:', response.data);
      const jobsData = response.data.data || response.data;
      console.log('Parsed Jobs Data:', jobsData);
      if (Array.isArray(jobsData) && jobsData.length > 0) {
        setJobs(jobsData);
      } else {
        setJobs([]);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching jobs:', error.message);
      setLoading(false);
      // Fallback to showing at least the CTA
      setJobs([]);
    }
  };

  const benefits = [
    {
      icon: '🏢',
      title: 'Flexible Work',
      description: 'Work remotely or from our modern office with flexible hours that suit your lifestyle.'
    },
    {
      icon: '📚',
      title: 'Learning & Growth',
      description: 'Continuous training, workshops, certifications, and mentorship programs to accelerate your career.'
    },
    {
      icon: '🍎',
      title: 'Health & Wellness',
      description: 'Comprehensive health insurance benefits, mental health support, and wellness programs.'
    },
    {
      icon: '🎉',
      title: 'Team Culture',
      description: 'Collaborative, inclusive, and fun work environment where everyone thrives together.'
    }
  ];

  return (
    <div className="career">
      {/* Hero Section */}
      <section className="career-hero" style={{ backgroundImage: "linear-gradient(135deg, rgba(10, 37, 64, 0.85), rgba(0, 82, 106, 0.85)), url('/images/cta-bg.jpg')" }}>
        <h1>Join Our Team</h1>
        <p>We're looking for passionate individuals to build the future of technology</p>
      </section>

      {/* Open Positions */}
      <section className="open-positions" ref={jobsRef}>
        <div className="positions-container">
          <h2>Current Openings</h2>
          <p className="section-desc">Explore our current openings and find your role</p>
          
          {loading ? (
            <p className="loading">⏳ Loading positions...</p>
          ) : jobs.length === 0 ? (
            <div className="no-jobs-message">
              <p>ℹ️ No jobs currently available, but we're always looking for talented people!</p>
            </div>
          ) : (
            <div className="jobs-list">
              {jobs.map((job) => (
                <div key={job.id} className="job-card">
                  <div className="job-header">
                    <h3>{job.title}</h3>
                    <span className="job-type">{job.job_type}</span>
                  </div>
                  <p className="job-description">{job.description}</p>
                  <div className="job-tags">
                    {job.requirements && job.requirements.split(',').map((req, idx) => (
                      <span key={idx} className="tag">{req.trim()}</span>
                    ))}
                    <span className="tag location">{job.location}</span>
                  </div>
                  <button 
                    className="btn-apply"
                    onClick={() => {
                      setSelectedJobId(job.id);
                      setShowApplicationModal(true);
                    }}
                  >
                    Apply Now →
                  </button>
                </div>
              ))}
            </div>
          )}

          {/* Career CTA - Only show when no jobs */}
          {!loading && jobs.length === 0 && (
            <div className="career-cta-box">
              <h3>Didn't find your role?</h3>
              <p>We're always interested in talented people. Send us your resume and tell us how you can make a difference.</p>
              <button className="btn-send-resume">Send Resume →</button>
            </div>
          )}
        </div>
      </section>

      {/* ===== MORE OPPORTUNITIES SECTION ===== */}
      <section className="more-opportunities" style={{ padding: '60px 0', backgroundColor: '#f8fafc' }}>
        <div style={{ maxWidth: '1180px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h2 style={{ fontSize: '32px', color: '#0f172a', fontWeight: '800', marginBottom: '10px' }}>
              More Opportunities at Pravara Infotech
            </h2>
            <p style={{ fontSize: '18px', color: '#64748b', fontWeight: '500' }}>
              Explore our Internship Programs and Project Services.
            </p>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
            gap: '30px',
            marginTop: '20px'
          }}>
            {/* CARD 1: Paid Internship Program */}
            <div className="opp-card" style={{
              background: 'rgba(255, 255, 255, 0.7)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(226, 232, 240, 0.8)',
              borderRadius: '20px',
              padding: '30px',
              boxShadow: '0 10px 30px -10px rgba(0, 0, 0, 0.05)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              transition: 'all 0.3s ease',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '4px',
                background: 'linear-gradient(90deg, #3b82f6, #60a5fa)'
              }} />
              <div>
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '12px',
                  background: 'rgba(59, 130, 246, 0.1)',
                  color: '#3b82f6',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                  marginBottom: '20px'
                }}>
                  <FaBriefcase />
                </div>
                <h3 style={{ fontSize: '22px', color: '#0f172a', fontWeight: '700', marginBottom: '12px' }}>
                  Paid Internship Program
                </h3>
                <p style={{ fontSize: '15px', color: '#64748b', lineHeight: '1.6', marginBottom: '20px' }}>
                  Join our Paid Internship Program designed for Software Development and MBA students. Gain practical industry experience by working on real-world projects under expert guidance.
                </p>
                <div style={{ marginBottom: '24px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '700', color: '#475569', display: 'block', marginBottom: '8px' }}>
                    Select Internship Domain:
                  </label>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      type="button"
                      onClick={() => setCardInternshipType('Software Development')}
                      style={{
                        flex: 1,
                        padding: '10px 12px',
                        borderRadius: '8px',
                        border: cardInternshipType === 'Software Development' ? '2px solid #3b82f6' : '1px solid #cbd5e1',
                        background: cardInternshipType === 'Software Development' ? 'rgba(59, 130, 246, 0.08)' : '#ffffff',
                        color: cardInternshipType === 'Software Development' ? '#3b82f6' : '#475569',
                        fontWeight: '700',
                        fontSize: '13px',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        textAlign: 'center'
                      }}
                    >
                      Software
                    </button>
                    <button
                      type="button"
                      onClick={() => setCardInternshipType('MBA')}
                      style={{
                        flex: 1,
                        padding: '10px 12px',
                        borderRadius: '8px',
                        border: cardInternshipType === 'MBA' ? '2px solid #3b82f6' : '1px solid #cbd5e1',
                        background: cardInternshipType === 'MBA' ? 'rgba(59, 130, 246, 0.08)' : '#ffffff',
                        color: cardInternshipType === 'MBA' ? '#3b82f6' : '#475569',
                        fontWeight: '700',
                        fontSize: '13px',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        textAlign: 'center'
                      }}
                    >
                      MBA
                    </button>
                  </div>
                </div>
              </div>
              <button 
                onClick={handleOpenInternshipModal}
                className="btn-apply-opp"
                style={{
                  background: '#3b82f6',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '12px 24px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  width: '100%',
                  transition: 'background-color 0.2s',
                  textAlign: 'center'
                }}
              >
                Apply Now
              </button>
            </div>

            {/* CARD 2: Software Project Enquiry */}
            <div className="opp-card" style={{
              background: 'rgba(255, 255, 255, 0.7)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(226, 232, 240, 0.8)',
              borderRadius: '20px',
              padding: '30px',
              boxShadow: '0 10px 30px -10px rgba(0, 0, 0, 0.05)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              transition: 'all 0.3s ease',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '4px',
                background: 'linear-gradient(90deg, #10b981, #34d399)'
              }} />
              <div>
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '12px',
                  background: 'rgba(16, 185, 129, 0.1)',
                  color: '#10b981',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                  marginBottom: '20px'
                }}>
                  <FaCode />
                </div>
                <h3 style={{ fontSize: '22px', color: '#0f172a', fontWeight: '700', marginBottom: '12px' }}>
                  Software Project Enquiry
                </h3>
                <p style={{ fontSize: '15px', color: '#64748b', lineHeight: '1.6', marginBottom: '24px' }}>
                  Looking for Final Year Projects, Mini Projects or Custom Software Development? Submit your project requirement and our team will contact you.
                </p>
              </div>
              <button 
                onClick={() => setShowSoftwareEnquiryModal(true)}
                className="btn-apply-opp"
                style={{
                  background: '#10b981',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '12px 24px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  width: '100%',
                  transition: 'background-color 0.2s',
                  textAlign: 'center'
                }}
              >
                Enquire Now
              </button>
            </div>

            {/* CARD 3: MBA Project Enquiry */}
            <div className="opp-card" style={{
              background: 'rgba(255, 255, 255, 0.7)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(226, 232, 240, 0.8)',
              borderRadius: '20px',
              padding: '30px',
              boxShadow: '0 10px 30px -10px rgba(0, 0, 0, 0.05)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              transition: 'all 0.3s ease',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '4px',
                background: 'linear-gradient(90deg, #8b5cf6, #a78bfa)'
              }} />
              <div>
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '12px',
                  background: 'rgba(139, 92, 246, 0.1)',
                  color: '#8b5cf6',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                  marginBottom: '20px'
                }}>
                  <FaChartBar />
                </div>
                <h3 style={{ fontSize: '22px', color: '#0f172a', fontWeight: '700', marginBottom: '12px' }}>
                  MBA Project Enquiry
                </h3>
                <p style={{ fontSize: '15px', color: '#64748b', lineHeight: '1.6', marginBottom: '24px' }}>
                  Need an MBA Academic Project or Research Project? Submit your requirement and our experts will help you.
                </p>
              </div>
              <button 
                onClick={() => setShowMbaEnquiryModal(true)}
                className="btn-apply-opp"
                style={{
                  background: '#8b5cf6',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '12px 24px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  width: '100%',
                  transition: 'background-color 0.2s',
                  textAlign: 'center'
                }}
              >
                Enquire Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Why Join Us */}
      <section className="why-join">
        <div className="benefits-container">
          <h2>Why Work With Us</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Career CTA Final */}
      <section className="career-final-cta">
        <h2>Ready to Start Your Journey?</h2>
        <p>Take the first step towards a rewarding career at Pravara Infotech. We can't wait to meet you!</p>
        <div className="cta-buttons">
          <button className="btn-primary" onClick={() => {
            jobsRef.current?.scrollIntoView({ behavior: 'smooth' });
          }}>Apply Now →</button>
          <button className="btn-secondary" onClick={() => navigate('/about')}>Learn About Us</button>
        </div>
      </section>

      {/* Job Application Modal */}
      {showApplicationModal && (
        <div className="modal-overlay" onClick={() => setShowApplicationModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Submit Your Application</h2>
              <button className="btn-close" onClick={() => setShowApplicationModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              {successMessage && (
                <div className="success-message">{successMessage}</div>
              )}
              {formError && (
                <div className="error-alert">{formError}</div>
              )}
              <form onSubmit={async (e) => {
                e.preventDefault();
                setFormError('');
                
                // Validate name
                const trimmedName = applicationForm.name.trim();
                if (!trimmedName) {
                  setFormError('❌ Full name is required');
                  return;
                }
                if (trimmedName.length < 2) {
                  setFormError('❌ Name must be at least 2 characters long');
                  return;
                }
                if (trimmedName.length > 100) {
                  setFormError('❌ Name cannot exceed 100 characters');
                  return;
                }
                if (!/^[a-zA-Z\s'-]+$/.test(trimmedName)) {
                  setFormError('❌ Name can only contain letters, spaces, hyphens, and apostrophes');
                  return;
                }

                // Validate email format
                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                const trimmedEmail = applicationForm.email.trim();
                if (!trimmedEmail) {
                  setFormError('❌ Email is required');
                  return;
                }
                if (!emailRegex.test(trimmedEmail)) {
                  setFormError('❌ Invalid email format. Please enter a valid email address');
                  return;
                }
                if (trimmedEmail.length > 100) {
                  setFormError('❌ Email cannot exceed 100 characters');
                  return;
                }

                // Validate phone
                const trimmedPhone = applicationForm.phone.trim();
                if (!trimmedPhone) {
                  setFormError('❌ Phone number is required');
                  return;
                }
                if (!/^[0-9]+$/.test(trimmedPhone)) {
                  setFormError('❌ Phone can only contain numbers (0-9). No spaces, hyphens, or special characters allowed');
                  return;
                }
                if (trimmedPhone.length !== 10) {
                  setFormError('❌ Phone number must be exactly 10 digits');
                  return;
                }

                // Validate resume is selected
                if (!applicationForm.resume) {
                  setFormError('❌ Resume is required. Please upload your resume (PDF, DOC, DOCX)');
                  return;
                }

                // Validate file format
                const allowedFormats = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
                if (!allowedFormats.includes(applicationForm.resume.type)) {
                  setFormError('❌ Invalid resume format. Please upload PDF, DOC, or DOCX file');
                  return;
                }

                // Validate file size (max 5MB)
                if (applicationForm.resume.size > 5 * 1024 * 1024) {
                  setFormError('❌ Resume file is too large. Maximum size is 5MB');
                  return;
                }

                setSubmitting(true);
                try {
                  const formData = new FormData();
                  formData.append('job_id', selectedJobId);
                  formData.append('name', applicationForm.name);
                  formData.append('email', applicationForm.email);
                  formData.append('phone', applicationForm.phone);
                  formData.append('cover_letter', applicationForm.cover_letter);
                  formData.append('resume', applicationForm.resume);

                  const _hostname = window.location.hostname;
                  const API_BASE = (_hostname && _hostname !== 'localhost' && _hostname !== '127.0.0.1')
                    ? 'https://pravarainfotech.in/api'
                    : (process.env.REACT_APP_API_URL || 'http://localhost:8000/api');
                  const response = await axios.post(`${API_BASE}/applications`, formData, {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                  });

                  if (response.data.success) {
                    setSuccessMessage('✓ Application submitted successfully!');
                    setApplicationForm({ name: '', email: '', phone: '', cover_letter: '', resume: null });
                    setTimeout(() => {
                      setShowApplicationModal(false);
                      setSuccessMessage('');
                    }, 2000);
                  }
                } catch (error) {
                  console.error('Error submitting application:', error);
                  setFormError(error.response?.data?.detail || '❌ Error submitting application. Please try again.');
                } finally {
                  setSubmitting(false);
                }
              }}>
                <div className="form-group">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    value={applicationForm.name}
                    onChange={(e) => setApplicationForm({...applicationForm, name: e.target.value})}
                    placeholder="Your full name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    value={applicationForm.email}
                    onChange={(e) => setApplicationForm({...applicationForm, email: e.target.value})}
                    placeholder="Your email"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Phone Number *</label>
                  <input
                    type="tel"
                    value={applicationForm.phone}
                    onChange={(e) => {
                      // Only allow digits (0-9)
                      const digitsOnly = e.target.value.replace(/[^0-9]/g, '');
                      // Limit to 10 digits
                      const limitedPhone = digitsOnly.slice(0, 10);
                      setApplicationForm({...applicationForm, phone: limitedPhone});
                    }}
                    placeholder="Enter 10-digit phone number"
                    maxLength="10"
                    pattern="[0-9]*"
                    inputMode="numeric"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Resume (PDF, DOC, DOCX) * <span className="file-size-hint">Max 5MB</span></label>
                  <input
                    type="file"
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        setApplicationForm({...applicationForm, resume: e.target.files[0]});
                        setFormError('');
                      }
                    }}
                    accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    className="file-input"
                    required
                  />
                  {applicationForm.resume && (
                    <p className="file-selected">✓ {applicationForm.resume.name} ({(applicationForm.resume.size / 1024).toFixed(2)} KB)</p>
                  )}
                </div>
                <div className="form-group">
                  <label>Cover Letter</label>
                  <textarea
                    value={applicationForm.cover_letter}
                    onChange={(e) => setApplicationForm({...applicationForm, cover_letter: e.target.value})}
                    placeholder="Tell us why you're interested in this position..."
                    rows="5"
                  />
                </div>
                <button type="submit" className="btn-submit" disabled={submitting}>
                  {submitting ? 'Submitting...' : 'Submit Application'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ===== INTERNSHIP REGISTRATION MODAL ===== */}
      {showInternshipModal && (
        <div className="modal-overlay" onClick={() => { setShowInternshipModal(false); setOppError(''); }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header" style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)' }}>
              <h2>Internship Registration</h2>
              <button className="btn-close" onClick={() => { setShowInternshipModal(false); setOppError(''); }}>✕</button>
            </div>
            <div className="modal-body">
              {oppError && <div className="error-alert">{oppError}</div>}
              <form onSubmit={(e) => handleOppSubmit(e, 'internship')}>
                <div className="form-group">
                  <label>Full Name *</label>
                  <input 
                    type="text" 
                    placeholder="Enter your full name" 
                    value={internshipForm.fullName}
                    onChange={(e) => setInternshipForm({...internshipForm, fullName: e.target.value})}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Mobile Number *</label>
                  <input 
                    type="tel" 
                    placeholder="10-digit mobile number" 
                    value={internshipForm.mobile}
                    onChange={(e) => {
                      const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                      setInternshipForm({...internshipForm, mobile: val});
                    }}
                    maxLength="10"
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Email Address *</label>
                  <input 
                    type="email" 
                    placeholder="yourname@email.com" 
                    value={internshipForm.email}
                    onChange={(e) => setInternshipForm({...internshipForm, email: e.target.value})}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>College Name *</label>
                  <input 
                    type="text" 
                    placeholder="Enter your college name" 
                    value={internshipForm.collegeName}
                    onChange={(e) => setInternshipForm({...internshipForm, collegeName: e.target.value})}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>University *</label>
                  <input 
                    type="text" 
                    placeholder="e.g. SPPU, BAMU" 
                    value={internshipForm.university}
                    onChange={(e) => setInternshipForm({...internshipForm, university: e.target.value})}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Current Year / Semester *</label>
                  <input 
                    type="text" 
                    placeholder="e.g. BE 4th Year, MBA 2nd Sem" 
                    value={internshipForm.currentYear}
                    onChange={(e) => setInternshipForm({...internshipForm, currentYear: e.target.value})}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>City *</label>
                  <input 
                    type="text" 
                    placeholder="Enter your city" 
                    value={internshipForm.city}
                    onChange={(e) => setInternshipForm({...internshipForm, city: e.target.value})}
                    required 
                  />
                </div>

                <div className="form-group">
                  <label>{internshipForm.internshipType === 'Software Development' ? 'Select Domain / Technology *' : 'Select Specialization *'}</label>
                  <select
                    value={internshipForm.internshipSubtype}
                    onChange={(e) => setInternshipForm({...internshipForm, internshipSubtype: e.target.value})}
                    style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }}
                    required
                  >
                    {internshipForm.internshipType === 'Software Development' ? (
                      <>
                        <option value="Python">Python</option>
                        <option value="Java">Java</option>
                        <option value="AI / ML">AI / ML</option>
                        <option value="Web Development (MERN)">Web Development (MERN)</option>
                        <option value="Android / Flutter">Android / Flutter</option>
                        <option value="Data Science">Data Science</option>
                      </>
                    ) : (
                      <>
                        <option value="Marketing">Marketing</option>
                        <option value="HR">HR</option>
                        <option value="Finance">Finance</option>
                        <option value="Business Analytics">Business Analytics</option>
                        <option value="Operations / Supply Chain">Operations / Supply Chain</option>
                        <option value="Others">Others</option>
                      </>
                    )}
                  </select>
                </div>

                <div className="form-group">
                  <label>Preferred Mode *</label>
                  <select 
                    value={internshipForm.preferredMode}
                    onChange={(e) => setInternshipForm({...internshipForm, preferredMode: e.target.value})}
                    style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }}
                  >
                    <option value="Online">Online</option>
                    <option value="Offline">Offline</option>
                    <option value="Hybrid">Hybrid</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Resume Upload (PDF only) (Optional) <span className="file-size-hint">Max 10MB</span></label>
                  <input 
                    type="file" 
                    accept=".pdf"
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        setInternshipForm({...internshipForm, resume: e.target.files[0]});
                        setOppError('');
                      }
                    }}
                  />
                  {internshipForm.resume && (
                    <p className="file-selected">✓ {internshipForm.resume.name} ({(internshipForm.resume.size / 1024 / 1024).toFixed(2)} MB)</p>
                  )}
                </div>

                <div className="form-group">
                  <label>Message (Optional)</label>
                  <textarea 
                    placeholder="Enter any additional details or messages..." 
                    value={internshipForm.message}
                    onChange={(e) => setInternshipForm({...internshipForm, message: e.target.value})}
                    rows="4"
                  />
                </div>

                <button type="submit" className="btn-submit" style={{ background: '#3b82f6' }} disabled={oppSubmitting}>
                  {oppSubmitting ? 'Submitting...' : 'Submit Registration'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ===== SOFTWARE PROJECT ENQUIRY MODAL ===== */}
      {showSoftwareEnquiryModal && (
        <div className="modal-overlay" onClick={() => { setShowSoftwareEnquiryModal(false); setOppError(''); }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header" style={{ background: 'linear-gradient(135deg, #10b981 0%, #047857 100%)' }}>
              <h2>Software Project Enquiry</h2>
              <button className="btn-close" onClick={() => { setShowSoftwareEnquiryModal(false); setOppError(''); }}>✕</button>
            </div>
            <div className="modal-body">
              {oppError && <div className="error-alert">{oppError}</div>}
              <form onSubmit={(e) => handleOppSubmit(e, 'software')}>
                <h3 style={{ fontSize: '16px', color: '#10b981', borderBottom: '1px solid #e2e8f0', paddingBottom: '6px', marginBottom: '15px' }}>Personal Details</h3>
                
                <div className="form-group">
                  <label>Full Name *</label>
                  <input 
                    type="text" 
                    placeholder="Enter your full name" 
                    value={softwareForm.fullName}
                    onChange={(e) => setSoftwareForm({...softwareForm, fullName: e.target.value})}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Mobile Number *</label>
                  <input 
                    type="tel" 
                    placeholder="10-digit mobile number" 
                    value={softwareForm.mobile}
                    onChange={(e) => {
                      const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                      setSoftwareForm({...softwareForm, mobile: val});
                    }}
                    maxLength="10"
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input 
                    type="email" 
                    placeholder="yourname@email.com" 
                    value={softwareForm.email}
                    onChange={(e) => setSoftwareForm({...softwareForm, email: e.target.value})}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>College Name</label>
                  <input 
                    type="text" 
                    placeholder="Enter college name" 
                    value={softwareForm.college}
                    onChange={(e) => setSoftwareForm({...softwareForm, college: e.target.value})}
                  />
                </div>

                <h3 style={{ fontSize: '16px', color: '#10b981', borderBottom: '1px solid #e2e8f0', paddingBottom: '6px', marginBottom: '15px', marginTop: '25px' }}>Project Details</h3>

                <div className="form-group">
                  <label>Project Title *</label>
                  <input 
                    type="text" 
                    placeholder="e.g. Hospital Management System" 
                    value={softwareForm.projectTitle}
                    onChange={(e) => setSoftwareForm({...softwareForm, projectTitle: e.target.value})}
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <label>Project Type *</label>
                  <select 
                    value={softwareForm.projectType}
                    onChange={(e) => setSoftwareForm({...softwareForm, projectType: e.target.value})}
                    style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }}
                  >
                    <option value="Mini Project">Mini Project</option>
                    <option value="Final Year Project">Final Year Project</option>
                    <option value="Custom Software">Custom Software</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Technology *</label>
                  <select 
                    value={softwareForm.technology}
                    onChange={(e) => setSoftwareForm({...softwareForm, technology: e.target.value})}
                    style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }}
                  >
                    <option value="Python">Python</option>
                    <option value="Java">Java</option>
                    <option value="PHP">PHP</option>
                    <option value="React">React</option>
                    <option value="Angular">Angular</option>
                    <option value="Flutter">Flutter</option>
                    <option value="Android">Android</option>
                    <option value="Node.js">Node.js</option>
                    <option value="FastAPI">FastAPI</option>
                    <option value="Django">Django</option>
                    <option value=".NET">.NET</option>
                    <option value="Laravel">Laravel</option>
                    <option value="MERN">MERN</option>
                    <option value="Others">Others</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Project Requirement *</label>
                  <textarea 
                    placeholder="Please explain: project idea, requirements, or desired features..." 
                    value={softwareForm.projectRequirement}
                    onChange={(e) => setSoftwareForm({...softwareForm, projectRequirement: e.target.value})}
                    rows="5"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Upload Requirement Document <span className="file-size-hint">PDF, DOC, DOCX - Max 10MB</span></label>
                  <input 
                    type="file" 
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        setSoftwareForm({...softwareForm, document: e.target.files[0]});
                        setOppError('');
                      }
                    }}
                  />
                  {softwareForm.document && (
                    <p className="file-selected">✓ {softwareForm.document.name} ({(softwareForm.document.size / 1024 / 1024).toFixed(2)} MB)</p>
                  )}
                </div>

                <button type="submit" className="btn-submit" style={{ background: '#10b981' }} disabled={oppSubmitting}>
                  {oppSubmitting ? 'Submitting...' : 'Submit Enquiry'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ===== MBA PROJECT ENQUIRY MODAL ===== */}
      {showMbaEnquiryModal && (
        <div className="modal-overlay" onClick={() => { setShowMbaEnquiryModal(false); setOppError(''); }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header" style={{ background: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)' }}>
              <h2>MBA Project Enquiry</h2>
              <button className="btn-close" onClick={() => { setShowMbaEnquiryModal(false); setOppError(''); }}>✕</button>
            </div>
            <div className="modal-body">
              {oppError && <div className="error-alert">{oppError}</div>}
              <form onSubmit={(e) => handleOppSubmit(e, 'mba')}>
                <div className="form-group">
                  <label>Full Name *</label>
                  <input 
                    type="text" 
                    placeholder="Enter your full name" 
                    value={mbaForm.fullName}
                    onChange={(e) => setMbaForm({...mbaForm, fullName: e.target.value})}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Mobile Number *</label>
                  <input 
                    type="tel" 
                    placeholder="10-digit mobile number" 
                    value={mbaForm.mobile}
                    onChange={(e) => {
                      const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                      setMbaForm({...mbaForm, mobile: val});
                    }}
                    maxLength="10"
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input 
                    type="email" 
                    placeholder="yourname@email.com" 
                    value={mbaForm.email}
                    onChange={(e) => setMbaForm({...mbaForm, email: e.target.value})}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>College *</label>
                  <input 
                    type="text" 
                    placeholder="Enter college name" 
                    value={mbaForm.college}
                    onChange={(e) => setMbaForm({...mbaForm, college: e.target.value})}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>University *</label>
                  <input 
                    type="text" 
                    placeholder="e.g. SPPU, BAMU, DY Patil" 
                    value={mbaForm.university}
                    onChange={(e) => setMbaForm({...mbaForm, university: e.target.value})}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Project Title *</label>
                  <input 
                    type="text" 
                    placeholder="e.g. Customer Satisfaction Analysis" 
                    value={mbaForm.projectTitle}
                    onChange={(e) => setMbaForm({...mbaForm, projectTitle: e.target.value})}
                    required 
                  />
                </div>

                <div className="form-group">
                  <label>Specialization *</label>
                  <select 
                    value={mbaForm.specialization}
                    onChange={(e) => setMbaForm({...mbaForm, specialization: e.target.value})}
                    style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }}
                  >
                    <option value="Marketing">Marketing</option>
                    <option value="Finance">Finance</option>
                    <option value="HR">HR</option>
                    <option value="Operations">Operations</option>
                    <option value="Business Analytics">Business Analytics</option>
                    <option value="Supply Chain">Supply Chain</option>
                    <option value="Others">Others</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Project Requirement / Description</label>
                  <textarea 
                    placeholder="Describe your research project objectives, survey requirements, or other guidelines..." 
                    value={mbaForm.projectRequirement}
                    onChange={(e) => setMbaForm({...mbaForm, projectRequirement: e.target.value})}
                    rows="4"
                  />
                </div>

                <div className="form-group">
                  <label>Upload Requirement Document <span className="file-size-hint">PDF, DOC, DOCX - Max 10MB</span></label>
                  <input 
                    type="file" 
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        setMbaForm({...mbaForm, document: e.target.files[0]});
                        setOppError('');
                      }
                    }}
                  />
                  {mbaForm.document && (
                    <p className="file-selected">✓ {mbaForm.document.name} ({(mbaForm.document.size / 1024 / 1024).toFixed(2)} MB)</p>
                  )}
                </div>

                <button type="submit" className="btn-submit" style={{ background: '#8b5cf6' }} disabled={oppSubmitting}>
                  {oppSubmitting ? 'Submitting...' : 'Submit Enquiry'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ===== PREMIUM SUCCESS MODAL ===== */}
      {showSuccessModal && (
        <div className="modal-overlay" onClick={() => setShowSuccessModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '420px', borderRadius: '20px', padding: '10px' }}>
            <div className="modal-body" style={{ textAlign: 'center', padding: '40px 30px' }}>
              <div className="checkmark-wrapper" style={{ marginBottom: '25px', display: 'inline-flex', background: 'rgba(16, 185, 129, 0.1)', color: '#10b981', width: '80px', height: '80px', borderRadius: '50%', alignItems: 'center', justifyContent: 'center', fontSize: '42px' }}>
                <FaCheckCircle style={{ animation: 'bounce 1s infinite alternate' }} />
              </div>
              <h2 style={{ fontSize: '24px', color: '#0f172a', fontWeight: '800', marginBottom: '15px' }}>Submitted Successfully!</h2>
              <p style={{ fontSize: '15px', color: '#64748b', lineHeight: '1.6', marginBottom: '20px' }}>
                Thank you for contacting Pravara Infotech. <br /> Our team will review your enquiry and contact you shortly.
              </p>
              {submittedId && (
                <div style={{ background: '#f1f5f9', border: '1px dashed #cbd5e0', padding: '10px 15px', borderRadius: '8px', fontSize: '13px', color: '#475569', fontWeight: '600', marginBottom: '25px' }}>
                  Reference ID: <span style={{ color: '#0f172a' }}>{submittedId}</span>
                </div>
              )}
              <button 
                onClick={() => setShowSuccessModal(false)} 
                className="btn-submit" 
                style={{ background: '#0f172a', color: '#ffffff', border: 'none', width: 'auto', padding: '12px 40px', borderRadius: '10px', cursor: 'pointer' }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Career;
